import { createAction, props, Action } from '@ngrx/store';
import { ICorrelationParams } from '@nx-ng/types';
import { ApiError } from '../client/src';
import { Order } from '../client/src/models';

export const LOAD_ORDER_TYPE = '[Order] Load Order API';
export const orderAPI_loadOrder = createAction(
  LOAD_ORDER_TYPE,
  props<{ orderNumber: string }>()
);

export const orderAPI_loadOrderSuccess = createAction(
  `${LOAD_ORDER_TYPE} Success`,
  props<{ response: Order }>()
);

export const orderAPI_loadOrderFailure = createAction(
  `${LOAD_ORDER_TYPE} Failure`,
  props<{ error?: string | ApiError; retryAction?: Action }>()
);

export const clearOrder = createAction('[Order] Clear Order');

export const loadOrderTickets = createAction(
  '[Order] Load Order Tickets',
  props<{ correlationParams?: ICorrelationParams }>()
);

export const loadOrderTicketsFailure = createAction(
  `Load Order Tickets Failure`
);

export const sendOrderCompleteToGtm = createAction(
  `Send Order Complete to GTM`
);
